import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment';
import { UtilService } from '@sharedServices/util.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class AdminAppService {

  public userName: string = ''

  constructor(
    private httpClient: HttpClient,
    private utilService: UtilService
  ) {}

  getEmployeeName = (): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/admin/employee/get/data', {
      params: { email: this.utilService.getCurrentUserEmail() }
    });
  }

  getEnumByName = (name: string): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/general/getEnumByName/' + name)
  }

  getLocationByPincode = (pinCode): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/location', {
      params: { pincode: pinCode }
    })
  }

  getCouponDataList = (data): Observable<any> => {
    return this.httpClient.post(environment.javaServerUrl + '/admin/hospital/get/coupons', data)
  }

  getOTP = (contactNumber, source): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/get/sendotp', {
      params: {
        mobile: contactNumber,
        source: source
      }
    })
  }

  getNonLoyaltyHospitalsList = (data): Observable<any> => {
    return this.httpClient.post(environment.nodeServerUrl + '/hospital/getNonLoyaltyHospitals', data)
  }

  getAllActivatedHospitals = (productType?: string): Observable<any> => {
    let params: any = {}

    if(productType) params = { productType: productType }
    return this.httpClient.get(environment.javaServerUrl + '/admin/hospital/get/allactivehospitaldisplaynames',
      { params }
    )
  }

  getAllActivatedInstitutions(): Observable<any> {
    return this.httpClient.get(environment.thorJavaServerUrl + '/admin/institution/get/activeinstitutions')
  }

  getLoanLeadStatus = (): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/general/getEnumByName/loanLeadStatus')
  }

  getProductSpecialization = (): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/general/getEnumByName/product_specialization')
  }

  getModeOfPayment = (): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/general/getEnumByName/modeOfPayment')
  }

  getReserveType = (): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/general/getEnumByName/reserveType')
  }

  getRelationWithCustomer = (): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/general/getEnumByName/relationWithCustomer')
  }

  getFoundUsThrough = (): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/general/getEnumByName/foundUsThrough')
  }

  getAffordplanCities = (): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/general/getEnumByName/affordplanCities')
  }

  getLeadOrInquiryDropdown = (): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/general/getEnumByName/leadOrInquiryDropdown')
  }

  getConnectedDesposition = (): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/general/getEnumByName/connectedDesposition')
  }

  getNonConnectedDesposition = (): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/general/getEnumByName/notConnectedDesposition')
  }

  getLeadSource = (): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/general/getEnumByName/leadSource')
  }

  getNbfcDetails = (): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/admin/loan/get/nbfcdetails')
  }

  fetchStates = (): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/get/states')
  }

  fetchZones = (): Observable<any> => {
    return this.httpClient.get(environment.nodeServerUrl + '/location/getZones')
  }

  fetchAreas = (stateName): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/get/areabystate', {
      params: { stateName: stateName }
    })
  }

  getCitiesByState = (stateId): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/get/citiesbystate', {
      params: { stateId: stateId }
    })
  }

  updateUserData = (data) : Observable<any> => {
    return this.httpClient.post(environment.nodeServerUrl + '/user/updateUser', data)
  }

  changePassword = (data): Observable<any> => {
    return this.httpClient.post(environment.javaServerUrl + '/admin/change/password', data)
  }

  addAdditionalHospitalDetails = (data): Observable<any> => {
    return this.httpClient.post(environment.javaServerUrl + '/admin/hospital/update/json', data)
  }

  getOfficeHubList = (): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/admin/happay/get/officehub')
  }

  getImgData = (requestObj): Observable<any> => {
    return this.httpClient.post(environment.javaServerUrl + '/admin/image/getbysemiurl', requestObj)
  }

  getInsuranceVendorDataList = (requestObj): Observable<any> => {
    return this.httpClient.post(environment.insuranceServerUrl + '/api/insurance/getInsuranceVendors', requestObj)
  }

  getSpecializationDataList = (requestObj): Observable<any> => {
    return this.httpClient.post(environment.nodeServerUrl + '/hospital/getSpecializations', requestObj)
  }

  getHospitalLeadData = (requestObj): Observable<any> => {
    return this.httpClient.get(environment.javaServerUrl + '/admin/lead/get/hospitalleadby', {
      params: requestObj
    })
  }

  getEmployeeListByRole = (role: string): Observable<any> => {
    return this.httpClient.get(environment.qaJavaServerUrl + '/admin/employee/get/all', {
      params: { role: role }
    })
  }

  updateHospitalDetails = (requestObj): Observable<any> => {
    return this.httpClient.post(environment.javaServerUrl + '/admin/hospital/save/json', requestObj)
  }

  getCityByName = (requestObj): Observable<any> => {
    return this.httpClient.post(environment.nodeServerUrl + '/location/getCities', requestObj)
  }

  getZones = (requestObj): Observable<any> => {
    return this.httpClient.post(environment.nodeServerUrl + '/location/getZones', requestObj)
  }

  getLocationByName = (requestObj): Observable<any> => {
    return this.httpClient.post(environment.nodeServerUrl + '/location/getLocations', requestObj)
  }
  
  getWalletKpiDetails(requestObj) {
    return this.httpClient.post(environment.thorJavaServerUrl + '/admin/super/get/chart/datewisewalletkpi', requestObj)
  }

  getCareApiRequests(requestObj) : Observable<any> {
    return this.httpClient.post(environment.nodeServerUrl + '/monitoring/getCareApiRequests', requestObj)
  }

  getYesbankApiRequests(requestObj) : Observable<any> {
    return this.httpClient.post(environment.nodeServerUrl + '/monitoring/getYesbankApiRequests', requestObj)
  }

  sendFailedApiMail(requestObj) : Observable<any> {
    return this.httpClient.post(environment.nodeServerUrl + '/monitoring/sendFailedApiEmail', requestObj)
  }

  getPickupDepositStatus(requestObj) {
    return this.httpClient.get(environment.qaJavaServerUrl + '/admin/pickupdeposit/get/minpickupdepositbycollectorstatus',
                               { params : requestObj })
  }

  getCollectorDepositStatus(requestObj) {
    return this.httpClient.get(environment.qaJavaServerUrl + '/admin/pickupdeposit/get/depositbyassigneebystatus', 
                               { params : requestObj })
  }

  getHospitalSpecializations = (hospitalDisplayName): Observable<any> => {
    return this.httpClient.post(environment.nodeServerUrl + '/hospital/getHospitalSpecializations', { hospitalDisplayName })
  }

  getHospitalQrCashbacks = (hospitalDisplayName): Observable<any> => {
    return this.httpClient.post(environment.nodeServerUrl + '/hospital/getHospitalQrCashbacks', { hospitalDisplayName })
  }
  
  getAllZones() : Observable<any> {
    return this.httpClient.get(environment.javaServerUrl + '/get/zones')
  }

  getFloatBalance(requestObj) {
    return this.httpClient.post(environment.insuranceServerUrl + '/api/insurance/monitorCareFloatBalance', requestObj)
  }

  
  sendWalletReactivationOtp(requestObj) {
    return this.httpClient.post(environment.javaServerUrl + '/admin/wallet/reactivation', requestObj)
  }

  validateWalletActivationOtp(requestObj) {
    return this.httpClient.post(environment.javaServerUrl + '/admin/wallet/reactivation/verify/otp', requestObj)
  }

}
